import { Box, CircularProgress, Typography } from '@mui/material';
import { signIn } from 'next-auth/react';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useAuthContext } from 'src/Core/hooks/AuthContext';

interface AuthenticationGuardProps {
  children: React.ReactNode;
}

export default function AuthenticationGuard({ children }: AuthenticationGuardProps) {
  const { session, status } = useAuthContext();
  const router = useRouter();
  const shouldSignIn = status === 'unauthenticated' || !!session?.error;
  const callbackUrlParam = router.query.callbackUrl;
  const loginCallbackUrl = (Array.isArray(callbackUrlParam) ? callbackUrlParam[0] : callbackUrlParam) || '/';
  const callbackUrl = router.pathname === '/login' ? loginCallbackUrl : router.asPath;

  useEffect(() => {
    if (!router.isReady || !shouldSignIn) return;
    void signIn('demo-identity-server', { callbackUrl });
  }, [router.isReady, callbackUrl, shouldSignIn]);

  if (status === 'loading') {
    return (
      <Box sx={{ position: 'absolute', margin: 0, top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
        <CircularProgress />
        <Typography sx={{ paddingTop: '45px', transform: 'translate(-35%, -50%)' }} variant="body1">
          Vinn úr auðkenningu...
        </Typography>
      </Box>
    );
  }

  if (shouldSignIn) {
    return null;
  }

  return <>{children}</>;
}
